import React from 'react';
import {
  Box,
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  Paper,
} from '@mui/material';
import {
  Phone,
  Message,
  AutoAwesome,
  TrendingUp,
} from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export const DashboardPage: React.FC = () => {
  const navigate = useNavigate();

  const stats = [
    {
      title: 'Total Calls Made',
      value: '1,234',
      icon: <Phone />,
      color: '#1976d2',
      path: '/calls',
    },
    {
      title: 'SMS Messages',
      value: '5,678',
      icon: <Message />,
      color: '#2e7d32',
      path: '/twilio',
    },
    {
      title: 'Prompts Generated',
      value: '89',
      icon: <AutoAwesome />,
      color: '#dc004e',
      path: '/prompts',
    },
    {
      title: 'Success Rate',
      value: '94.2%',
      icon: <TrendingUp />,
      color: '#ed6c02',
      path: '/dashboard',
    },
  ];

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" gutterBottom>
        Welcome to HubOne Tools
      </Typography>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        {stats.map((stat, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Card
              sx={{
                cursor: 'pointer',
                transition: 'transform 0.2s',
                '&:hover': {
                  transform: 'translateY(-4px)',
                },
              }}
              onClick={() => navigate(stat.path)}
            >
              <CardContent>
                <Box display="flex" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography color="text.secondary" gutterBottom>
                      {stat.title}
                    </Typography>
                    <Typography variant="h4" component="div">
                      {stat.value}
                    </Typography>
                  </Box>
                  <Box
                    sx={{
                      color: stat.color,
                      fontSize: '2.5rem',
                    }}
                  >
                    {stat.icon}
                  </Box>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3} sx={{ mt: 2 }}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Quick Actions
            </Typography>
            <Box display="flex" flexDirection="column" gap={2}>
              <Button
                variant="contained"
                startIcon={<Phone />}
                onClick={() => navigate('/calls')}
                fullWidth
              >
                Manage Calls
              </Button>
              <Button
                variant="contained"
                startIcon={<Message />}
                onClick={() => navigate('/twilio')}
                fullWidth
              >
                Export Twilio Data
              </Button>
              <Button
                variant="contained"
                startIcon={<AutoAwesome />}
                onClick={() => navigate('/prompts')}
                fullWidth
              >
                Generate Prompts
              </Button>
            </Box>
          </Paper>
        </Grid>
        
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>
              Recent Activity
            </Typography>
            <Typography color="text.secondary">
              No recent activity to display.
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};
